namespace TR {
    type TripService = Core.TripService;
    type HotelFromSessionService = Core.Hotels.HotelFromSessionService;
    type Occupancy = Core.AdHoc.Occupancy;
    export class BD4Travel {

        dateFormatter: any;
        trackFlightsResults: Function;
        currentSort: string;
        currentHotelRankingScoresToken: string;
        filter: any;
        storage: any;

        constructor(
            private bd4t: any,
            private $filter: any,
            private $q: ng.IQService,
            private $location: ng.ILocationService,
            private dateUtil: any,
            private filtering: any,
            private sortCriteria: any,
            private basketStore: any,
            private tripService: TripService,
            private preferences: any,
            private hotelFromSession: HotelFromSessionService,
            private currentUser: any,
            private $routeParams: any,
            private currentDestination: any,
            private objectTypeService: any,
            private localStorageProvider: any,
            private occupancyService: Core.OccupancyService,
        ) {
            this.dateFormatter = date => {
                if (!date) { return; }
                return this.$filter('date')(date, 'yyyy-MM-dd');
            };

            this.trackFlightsResults = _.debounce(this._trackFlightsResults, 800);

            this.initPrivacyLevel();
        }

        initPrivacyLevel() {
            let isOptIn = this.isOptIn();
            if (!isOptIn) {
                this.bd4t('privacy', {
                    level: 'non-personal'
                });
            }
        }

        private isOptIn() {
            try {
                if (!document.cookie.length) {
                    return false;
                }
                const cookie = 'bd4t-cookie-test=' + new Date().getTime();
                document.cookie = cookie;
                return document.cookie.indexOf(cookie) > -1;
            } catch (err) {
                return false;
            }
        }

        trackInitialParameters(searchModel, pageType) {
            if (!searchModel || !pageType) { return; }

            const origin:any = _.get(searchModel, 'airports');
            const destination:any = _.get(searchModel, 'destination[0]');
            const startDate = this.dateUtil.parseDate(_.get(searchModel, 'startDate'));
            const endDate = this.dateUtil.parseDate(_.get(searchModel, 'endDate'));
            const isFlexible = _.get(searchModel, 'flexibleDates');
            const duration = this.dateUtil.getDifferenceInDays(startDate, endDate);
            const occupancy = _.get<any[]>(searchModel, 'occupancy');

            const filter = {
                origin: _.map(origin, (a:any) => a.Code),
                destination: this._normaliseDestination(destination),
                period: {
                    from: this.dateFormatter(this.dateUtil.addDays(startDate, isFlexible ? -3 : 0)),
                    to: this.dateFormatter(this.dateUtil.addDays(endDate, isFlexible ? 3 : 0)),
                },
                duration: {
                    min: duration,
                    max: duration
                },
                rooms: _.map(occupancy, (o:any) => ({ adults: o.Adults, childAges: o.ChildAges }))
            };

            let types = pageType.split(',');
            if (types[0] === 'categoryDetails') {
                let currentPath = _.camelCase(this.$location.path().split('/').pop());
                types[0] = `${types[0]}:${currentPath}`;
            }
            this._initPage(types[0], types[1] || 'landingpage');

            this.getCurrentProduct()
                .then(product => {
                    this._setContext({
                        product,
                        filter,
                    }, false);
                })
                .catch(angular.noop)
                .then(() => this._pageview());
        }

        private getCurrentProduct() {
            return this.currentDestination.getCurrentDestination({
                useTrip: false,
                useLandingPage: true,
                useSearchUnitService: false
            })
            .then(d => {
                if (d && d.Type === 1) {
                    return {
                        type: d.PageStrand === 1 ? 'hotel' : 'package',
                        id: `tr:${d.Id}`
                    };
                }
                if (this.$routeParams.estabId) {
                    return {
                        type: this.$location.url().indexOf('hotels') > -1 ? 'hotel' : 'package',
                        id: `tr:${this.$routeParams.estabId}`
                    };
                }
            });
        }

        trackHotelResults(trip, results, currentRequest) {
            this.currentSort = (results.RankingScoresToken && results.RankingScoresToken.indexOf('_X') === -1)
                ? 'relevance' : this.sortCriteria.translateHotelSort(currentRequest.SortCriterion).label;

            this.currentHotelRankingScoresToken =
                results.RankingScoresToken && results.RankingScoresToken.replace('_X', '');

            this.$q.when()
                .then(() => {
                    let basketId = _.get(trip, 'BasketId');
                    if (basketId) {
                        return this.basketStore.flight(basketId);
                    }
                })
                .then(f => this._buildHotelResults(trip, results, currentRequest, f)
            );
        }

        trackHotelAvailability(tripId, estabId, pageType) {
            this.tripService.getTrip(tripId).then(trip => {
                const tripType = _.get(trip, 'TripType');
                const tripTypes = this.tripService.tripTypes;

                this.$q.all([
                    this.basketStore.flight(trip.BasketId),
                    this.hotelFromSession.getHotel(
                        _.get<string>(trip, 'HotelsRequest.AvailabilitySearchId'),
                        estabId,
                        _.get<string>(trip, 'TripId')
                    ),
                    this.basketStore.costBreakdownGrouped(_.get(trip, 'BasketId'))
                ]).then(([ flight, hotel, cost ]) => {
                    if (tripType !== tripTypes.Hotel && tripType !== tripTypes.Holiday) {
                        return;
                    }

                    const offer = this.extractOfferFromTrip(trip, flight, hotel, cost);
                    const product = {
                        type: tripType === tripTypes.Hotel ? 'hotel' : 'package',
                        id: `tr:${estabId}`
                    };

                    this._initPage(pageType, tripType === tripTypes.Hotel ? 'hotel' : 'holidays');
                    this._setContext({ offer, product }, false);
                    this._pageview();
                });
            });
        }

        trackCategory(childDestinations) {
            childDestinations = this._normaliseDestination(childDestinations);
            this._setContext({ category: childDestinations });
            this._pageview();
        }

        availabilityCheck(trip, estabId, errorResponse) {
            return this.basketStore
                .flight(trip.BasketId)
                .then(f => this.$q.all([
                    this.basketStore.hotel(trip.BasketId),
                    this._enrichBasketInformation(estabId, f, trip)
                ]))
                .then(([ hotel, { costBreakDown, roomsList, flight } ]) =>
                    this._buildAvailabilityCheck(
                        estabId,
                        hotel,
                        flight,
                        trip,
                        costBreakDown,
                        roomsList,
                        errorResponse
                    )
                );
        }

        trackBookingForm(confirmed, hotel, flight, trip, fees) {
            const tripType = _.get(trip, 'TripType');
            if (tripType !== 2 && tripType !== 4) { return this.$q.when(); }
            return this._enrichBasketInformation(_.get(hotel, 'Details.Id'), flight, trip)
                .then(res => {
                    const { costBreakDown, roomsList } = res;
                    return this._buildBookingForm(
                        confirmed,
                        hotel,
                        flight,
                        trip,
                        costBreakDown,
                        roomsList,
                        fees
                    );
                });
        }

        trackEngagementClick = _.debounce(
            hotelId => {
                try {
                    this.tripService.getTrip(this.$routeParams.tripId)
                        .then(trip => {
                            const tripType = _.get(trip, 'TripType');
                            if (tripType) {
                                this._engagement({
                                    type: 'productDetails',
                                    product: {
                                        type: 'hotel',
                                        id: `tr:${hotelId}`
                                    },
                                    listId:  tripType === 2 ? 'hotel_list' : 'holidays_list',
                                });
                            }
                        });
                } catch (e) {}
            },
            200,
            { leading: true, trailing: false }
        );

        extractOfferFromTrip(trip, flight, hotel, cost) {
            const depDate:string = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
            const returnDate:string = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            const rooms = _.get<Occupancy[]>(trip, 'HotelsRequest.Rooms', []);
            const outboundLeg = _.get<any>(flight, 'Details.Itinerary.Legs[0]', {});
            const total = flight && flight.TotalAmount && hotel.MinCost ?
                          flight.TotalAmount + hotel.MinCost : _.get<number>(cost, 'total', 0);
            const occupancy = this.occupancyService.reduceOccupancy(rooms);

            return { //Details re the offer that the user selected
                period: {
                    from: this.dateFormatter(depDate),
                    to: this.dateFormatter(returnDate)
                },
                occupancy: {
                    adults: occupancy.Adults,
                    children: occupancy.ChildAges
                },
                price: { //it can be “pp” or “total” or both if available
                    total,
                    pp: parseFloat((total / this.occupancyService.getNumberOfNonInfantPassengers(occupancy)).toFixed(2))
                },
                origin: _.get(outboundLeg, 'DepartureAirport.Code', ''),
                airline: _.get(outboundLeg, 'Segments[0].CodeshareAirlineName', ''),
                arrivalAirport: _.get(outboundLeg, 'ArrivalAirport.Code', ''),
                rooms: _.map(rooms, room  => ({
                        occupancy: {
                            children: room.ChildAges,
                            adults: room.Adults
                        }
                    })
                ),
            };
        }

        extractFilterFromTrip(trip, isFlexible = false) {
            const airportsCodes:any = _.get(trip, 'FlightsRequest.SelectedDepartureAirport.Code');
            const destination:any = _.get(trip, 'HotelsRequest.Destination');
            let depDate = this.dateUtil.parseDate(_.get(trip, 'FlightsRequest.DepartureDate'));
            let returnDate = this.dateUtil.parseDate(_.get(trip, 'FlightsRequest.ReturnDate'));
            if (!depDate && !returnDate) {
                depDate = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
                returnDate = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            }
            const duration = this.dateUtil.getDifferenceInDays(depDate, returnDate);
            const rooms = _.get(trip, 'HotelsRequest.Rooms');

            return {
                origin: _.split(airportsCodes, ','),
                destination: this._normaliseDestination(destination),
                period: {
                    from: this.dateFormatter(this.dateUtil.addDays(depDate, isFlexible ? -3 : 0)),
                    to: this.dateFormatter(this.dateUtil.addDays(returnDate, isFlexible ? 3 : 0)),
                },
                duration: {
                    min: duration,
                    max: duration
                },
                rooms: _.map(rooms, (o:any) => ({ adults: o.Adults, childAges: o.ChildAges }))
            };
        }

        getContextFromSearch(searchModel, isHotel) {
            let filter = this.getFiltersFromSearch(searchModel, isHotel);
            filter = angular.copy(_.merge({}, this.filter, filter));
            return { filter };
        }

        getFiltersFromSearch(searchModel, isHotel = false) {
            if (!searchModel) { return; }

            const origin:any = !isHotel ? _.get(searchModel, 'airports') : undefined;
            const destination:any = _.get(searchModel, 'destination[0]') || _.get(searchModel, 'destination');
            const startDate = this.dateUtil.parseDate(_.get(searchModel, 'startDate'));
            const endDate = this.dateUtil.parseDate(_.get(searchModel, 'endDate'));
            const isFlexible = _.get(searchModel, 'flexibleDates') && !isHotel;
            const duration = this.dateUtil.getDifferenceInDays(startDate, endDate);
            const occupancy = _.get<any[]>(searchModel, 'occupancy');

            return {
                origin: _.map(origin, (a:any) => a.Code),
                destination: this._normaliseDestination(destination),
                period: {
                    from: this.dateFormatter(this.dateUtil.addDays(startDate, isFlexible ? -3 : 0)),
                    to: this.dateFormatter(this.dateUtil.addDays(endDate, isFlexible ? 3 : 0)),
                },
                duration: {
                    min: duration,
                    max: duration
                },
                rooms: _.map(occupancy, (o:any) => ({ adults: o.Adults, childAges: o.ChildAges }))
            };
        }

        clearContext() {
            return this.localStorageProvider.removeItem('bd4-context');
        }

        private _enrichBasketInformation(estabId, flight, trip) {
            return this.$q.all([
                this.hotelFromSession.getHotel(
                    _.get<string>(trip, 'HotelsRequest.AvailabilitySearchId'),
                    estabId,
                    _.get<string>(trip, 'TripId')
                ),
                this.basketStore.costBreakdownGrouped(_.get(trip, 'BasketId'))
            ])
            .then(res => {
                const [ hotelFromSession, costBreakDown ] = res;
                const roomsList = _.get(hotelFromSession, 'RequestedRooms[0].Availability');
                return { costBreakDown, roomsList, flight };
            });
        }

        private _trackFlightsResults(tripId) {
            this.$q.all([
                this.tripService.getTrip(tripId),
                this.preferences.get('search')
            ])
            .then(([trip, searchModel]) => {
                const flexibleDates = _.get<boolean>(searchModel, 'flexibleDates');
                const filter = this.extractFilterFromTrip(trip, flexibleDates);
                const tripType = _.get(trip, 'TripType');
                this._initPage('flightList', tripType === 2 ? 'hotel' : 'holidays');
                this._setContext({ filter });
                this._pageview();
            });
        }

        private _buildHotelResults(trip, results, currentRequest, flight) {
            const filters = _.get(currentRequest, 'FilterCriteria');
            const boardTypes:any = _.get(filters, 'BoardTypes');
            const stars:any = _.get(filters, 'Stars') || [];
            const nearTo = _.get<string[]>(filters, 'ChildDestinations') || [];
            const holidayTypes = _.get<string[]>(filters, 'FacilityCodes') || [];
            const propertyTypes = _.get<string[]>(filters, 'PropertyTypes') || [];
            const rating:any = _.get(filters, 'RatingRange') || _.get(results, 'Aggregates.RatingRange');
            const price:any = _.get(filters, 'PriceRange') || _.get(results, 'Aggregates.PriceRange');
            const tripType = _.get(trip, 'TripType');

            const filter = _.merge(
                this.extractFilterFromTrip(trip),
                {
                    board: _.map(
                        boardTypes,
                        (bt:any) => `tr:${this.filtering.getBoardTypeName(parseInt(bt, 10))}`
                    ),
                    categoryStars: _.map(stars, (s:any) => parseInt(s, 10)),
                    rating10: {
                        min: rating ? _.get<number>(rating, 'Min') * 10 : undefined,
                        max: rating ? _.get<number>(rating, 'Max') * 10 : undefined
                    },
                    price: {
                        min: _.get(price, 'Min'),
                        max: _.get(price, 'Max')
                    },
                    categories: [
                        ..._.map(nearTo, nt => `nearto:${nt}`),
                        ..._.map(holidayTypes, ht => `holiday:${ht}`),
                        ..._.map(propertyTypes, pt => `proptype:${pt}`)
                    ]
                }
            );

            const hotels = _.get<any[]>(results, 'Hotels');
            const sortValue = this.sortCriteria.translateHotelSort(
                _.get(currentRequest, 'SortCriterion')
            );
            const checkIn = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
            const checkOut = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            const departureAirport = _.get(
                flight,
                'Details.Itinerary.Legs[0].DepartureAirport.Code'
            );

            const productList = {
                listId:  tripType === 2 ? 'hotel_list' : 'holidays_list',
                pageIndex: _.get(currentRequest, 'Paging.Index'),
                pageSize: _.get(currentRequest, 'Paging.Size'),
                totalResults: _.get(results, 'Aggregates.FilteredHotelCount'),
                sort: [{
                    field: (results.RankingScoresToken && results.RankingScoresToken.indexOf('_X') === -1)
                        ? 'relevance' : _.get(sortValue, 'label'),
                    direction: _.get(sortValue, 'direction')
                }],
                tracking: {
                    activeExperiments: ['Amsterdam (new):test'],
                    activeConfigurations: ['Amsterdam']
                },
                elements: _.map(hotels, h => ({
                    type: tripType === 2 ? 'hotel' : 'package',
                    id: `tr:${_.get(h, 'Id')}`,
                    offer: {
                        period: {
                            from: this.dateFormatter(checkIn),
                            to: this.dateFormatter(checkOut)
                        },
                        origin: departureAirport,
                        price: this.getPriceObjectFromHotel(h)
                    }
                }))
            };

            this._initPage('productList', tripType === 2 ? 'hotel' : tripType === 4 ? 'holidays' : 'landingpage');
            this._setContext({ filter, productList });
            this._pageview();
        }

        private getPriceObjectFromHotel(h) {
            const total = (_.get(h, 'MinHolidayPrice'));
            let pp: string = (_.get(h, 'MinCostPerPerson') || _.get(h, 'TeaserStr') || '').toString();
            pp = pp.replace(/[^0-9.]/g, '');
            return {
                pp: parseFloat(pp),
                total
            };
        }

        private _buildAvailabilityCheck(estabId, hotel, flight, trip, costBreakdown, roomsList, res) {
            const totalCost = _.get<number>(costBreakdown, 'total');
            const rooms = _.get<any[]>(trip, 'HotelsRequest.Rooms');
            const occupancy = this.occupancyService.reduceOccupancy(rooms);
            const totalPeople = this.occupancyService.getNumberOfNonInfantPassengers(occupancy);

            const checkIn = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
            const checkOut = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            const boardTypeName = this._getBoardTypeName(hotel, roomsList);
            const tripType = _.get(trip, 'TripType');

            const product = {
                type: tripType === 2 ? 'hotel' : 'package',
                id: `tr:${estabId}`
            };

            let offer: any = {
                occupancy: {
                    adults: occupancy.Adults,
                    children: occupancy.ChildAges
                },
                price: {
                    pp: (totalCost / totalPeople).toFixed(2)
                },
                period: {
                    from: this.dateFormatter(checkIn),
                    to: this.dateFormatter(checkOut)
                },
                origin: _.get(flight, 'Details.Itinerary.Legs[0].DepartureAirport.Code'),
                rooms: _.map(rooms, (o:any) => ({ adults: o.Adults, childAges: o.ChildAges })),
            };

            if (boardTypeName) {
                offer.board = `tr:${boardTypeName}`;
            }

            this._initPage('engagement', 'holidays');
            const ac = {
                type: 'ac',
                section: tripType === 2 ? 'hotel' : 'holidays',
                product,
                offer
            };

            const err = { code: _.get(res, 'status'), message: _.get(res, 'statusText') };
            this._engagement(res
                ? _.set(ac, 'nonAvailability', err)
                : _.set(ac, 'actualPrice', { total: totalCost })
            );
        }

        private _buildBookingForm(confirmed, hotel, flight, trip, costBreakDown, roomsList, fees) {
            const rooms = _.get<Occupancy[]>(trip, 'HotelsRequest.Rooms');
            const checkIn = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
            const checkOut = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            const boardTypeName = this._getBoardTypeName(hotel, roomsList);
            const tripType = _.get(trip, 'TripType');
            const outboundLeg = _.get<any>(flight, 'Details.Itinerary.Legs[0]', {});
            const occupancy = this.occupancyService.reduceOccupancy(rooms);
            const total = _.get<number>(costBreakDown, 'total');
            const final = total + (_.get<number>(fees, 'CardHandlingFee') || 0);

            const product = {
                type: tripType === 2 ? 'hotel' : 'package',
                id: `tr:${_.get(hotel, 'Details.Id')}`
            };

            const offer = {
                occupancy: {
                    adults: occupancy.Adults,
                    children: occupancy.ChildAges,
                },
                price: {
                    total,
                    final,
                    pp: parseFloat((total / this.occupancyService.getNumberOfNonInfantPassengers(occupancy)).toFixed(2))
                },
                period: {
                    from: this.dateFormatter(checkIn),
                    to: this.dateFormatter(checkOut)
                },
                origin: _.get(outboundLeg, 'DepartureAirport.Code', ''),
                airline: _.get(outboundLeg, 'Segments[0].CodeshareAirlineName', ''),
                arrivalAirport: _.get(outboundLeg, 'ArrivalAirport.Code', ''),
                board: `tr:${boardTypeName}`,
                rooms: _.map(_.get(hotel, 'Details.BookedItems', []), (room:any)  => ({
                    type: room.RoomDescription,
                    board: boardTypeName,
                    occupancy: {
                        children: room.ChildAges,
                        adults: room.Adults
                    }
                }))
            };

            this._initPage(
                `booking:${confirmed ? 'confirmation' : 'form'}`,
                tripType === 2 ? 'hotel' : 'holidays',
                confirmed ? 2 : 1,
                2
            );

            const context = { product, offer };
            if (confirmed) {
                _.set(context, 'transactionId', _.get(trip, 'TripId'));
            }

            this._setContext(context, false)
                .then(() => this._pageviewImmediate());
        }

        private _initPage(
            type:any,
            section:any = undefined,
            funnelStep:any = undefined,
            totalFunnelSteps:any = undefined
        ) {
            const data = { type };
            if (section) { _.set(data, 'section', section); }
            if (funnelStep) { _.set(data, 'funnelStep', funnelStep); }
            if (totalFunnelSteps) { _.set(data, 'totalFunnelSteps', totalFunnelSteps); }
            this.bd4t('initPage', data);
        }

        private _setContext(data, mergeContext = true) {
            const user = this.currentUser.get() || {};
            this.filter = angular.copy(_.assign({}, this.filter, data.filter));

            if (!mergeContext) {
                this.bd4t('context', data);
                return this.$q.resolve();
            }

            return this.localStorageProvider.getItem('bd4-context')
                .then(context => {
                    context = {...context, ...data, ...{
                        uhandles: {
                            userIdHash: user.UserIdHash,
                            utmId: user.UtmId,
                        },
                        uhandle: user.UtmId,
                        filter: this.filter,
                    }};
                    this.bd4t('context', context);
                    return this.localStorageProvider.setItem('bd4-context', context);
                });
        }

        private _pageviewImmediate() {
            this.bd4t('send', 'pageview');
        }

        private _pageview = _.throttle(
            () => this._pageviewImmediate(),
            250,
            { leading: false, trailing: true }
        );

        //Who is ac?
        private _engagement(ac) {
            this.bd4t('send', 'engagement', ac);
        }

        private _getBoardTypeName(hotel, roomsList) {
            const boardDescription = this._normaliseName(
                _.get<string>(hotel, 'Details.BookedItems[0].BoardDescription')
            );
            let boardType;
            _.each(roomsList, room => {
                _.each(room.BoardOptions, boardOption => {
                    if (this._normaliseName(boardOption.BoardDescription) === boardDescription) {
                        boardType = boardOption.BoardType;
                    }
                });
            });
            return this.filtering.getBoardTypeName(boardType);
        }

        private _normaliseName(name: string) {
            return _.chain(name).lowerCase().replace(/\s/g, '').value();
        }

        private _normaliseDestination(destination: any) {
            if (!angular.isArray(destination)) {
                destination = [destination];
            }
            return _(destination)
                .map(d => {
                    if (d) {
                        d = this.objectTypeService.getObjectTypeAndId(d);
                        if (d.Type > 1 && d.Id) {
                            return `tr${d.Type}:${d.Id}`;
                        }
                    }
                })
                .filter(d => d)
                .value();
        }
    }

    angular
        .module('TR')
        .service('bd4travel', BD4Travel);
}
